import { render, staticRenderFns } from "./malmo.vue?vue&type=template&id=64adc28a&scoped=true&"
import script from "./malmo.vue?vue&type=script&lang=ts&"
export * from "./malmo.vue?vue&type=script&lang=ts&"
import style0 from "./malmo.vue?vue&type=style&index=0&id=64adc28a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64adc28a",
  null
  
)

/* custom blocks */
import block0 from "./malmo.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCol,VRow})
